/** InsCoder 2026-02-04 B + Rewards hero banner sticky header logic **/
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.rewards-pg-hero-banner').forEach((heroBanner) => {
        const stickyHeader = heroBanner.querySelector('.show-sticky');
        if (!stickyHeader) return;
    
        const observer = new IntersectionObserver(([entry]) => {
          if (entry.intersectionRatio < 0.5 && entry.boundingClientRect.top < 0) {
            stickyHeader.classList.add('is-visible');
          } else {
            stickyHeader.classList.remove('is-visible');
          }
        }, { threshold: [0, 0.5] });
    
        observer.observe(heroBanner);
      });
});
/** InsCoder 2026-02-04 E + Rewards hero banner sticky header logic **/
